import {
    get,
    post
} from '../utils/request';

// 修改用户
export const updateMember = params =>post('/member/updateMember',params);